/**
 * Copyright IBM Corp. 2022, 2026
 */

import { useEffect, useLayoutEffect } from 'react'

export default typeof window !== 'undefined' ? useLayoutEffect : useEffect
